import React from "react";
import responsiveDesign from "../../assets/icons/ui-design.png";
import webDesign from "../../assets/icons/001-web-design.png";
import fullStack from "../../assets/icons/full-stack.png";
import networking from "../../assets/icons/networking.png";
import AOS from "aos";
import "aos/dist/aos.css";
import { motion } from "framer-motion";

const MyServices = () => {
  AOS.init({
    delay: 0, // values from 0 to 3000, with step 50ms
    duration: 500,
  });
  return (
    <div id="services" className="  mb-20">
      <div className="text-center MyContainer pt-24  after:absolute after:content-['Services']  after:tracking-widest after:text-own-gray-black after:text-[4rem]   sm:after:text-[8rem] after:opacity-50 after:left-[50%] after:-translate-x-[50%] relative after:-z-10 after:top-[30px] after:font-semibold ">
        <div className="flex flex-col  relative justify-center items-center   before:animate-bounce">
          <span className=" inline-block  text-own-gray-white px-10 py-2  bg-own-primary bg-opacity-50 border-b-[2px] border-own-border-color border-opacity-10 text-xl mb-1 animate-bounce">
            What <span className="text-own-secondary">Can</span> I Do Best & My
            Services
          </span>
          <span className="text-own-secondary text-[2.5rem] font-semibold  rounded-md">
            My Services
          </span>
        </div>
        <div className="grid lg:grid-cols-4 md:grid-cols-2 grid-cols-1 gap-5 mt-14 text-left">
          <div data-aos="zoom-in" className="Tilt-inner ">
            <div className="bg-own-primary border-2 bg-opacity-20 glow-on-hover border-own-border-color border-opacity-10 shadow-lg p-5 relative rounded-md  lg:mb-0 mb-6 flex  flex-col justify-center items-center">
              <span className="">
                <img width="100px" src={webDesign} alt="" />
              </span>
              <h2 className="text-xl font-medium mt-6 text-own-gray-white  mb-2 ">
                Frontend Development
              </h2>
              <p className="text-center font-light text-own-ternary text-md">
                Professional Front End Web Developer, Free Minded , Clean & 100%
                Hand Writed Code
              </p>
            </div>
          </div>
          <div data-aos="zoom-in" className="Tilt-inner">
            <div className="bg-own-primary border-2 bg-opacity-20 border-own-border-color border-opacity-10 shadow-lg p-5 relative rounded-md glow-on-hover  lg:mb-0 mb-6 flex  flex-col justify-center items-center">
              <span className="">
                <img width="100px" src={responsiveDesign} alt="" />
              </span>
              <h2 className="text-xl font-medium mt-6 text-own-gray-white   mb-2 ">
                MERN Stack Developer
              </h2>
              <p className="text-center font-light text-own-ternary text-md">
                As a MERN Stack Web Developer, I'm responsible for making and
                maintaining a website. I can develop your website and make your
                website fast
              </p>
            </div>
          </div>
          <div data-aos="zoom-in" className="Tilt-inner">
            <div className="bg-own-primary border-2 bg-opacity-20 border-own-border-color border-opacity-10 shadow-lg p-5 relative rounded-md glow-on-hover lg:mb-0 mb-6 flex  flex-col justify-center items-center">
              <span className="">
                <img width="100px" src={fullStack} alt="" />
              </span>
              <h2 className="text-xl font-medium mt-6 text-own-gray-white  mb-2 ">
                Bug Cleaning
              </h2>
              <p className="text-center font-light text-own-ternary text-md">
                A simple Bug can destroy your website it can make your site
                useless.Hire me if there any bugs in your website . I will take
                care of them
              </p>
            </div>
          </div>
          <div data-aos="zoom-in" className="Tilt-inner">
            <div className="bg-own-primary border-2 bg-opacity-20 border-own-border-color border-opacity-10 shadow-lg p-5 relative rounded-md glow-on-hover  lg:mb-0 mb-6 flex  flex-col justify-center items-center">
              <span className="">
                <img width="100px" src={networking} alt="" />
              </span>
              <h2 className="text-xl font-medium mt-6 text-own-gray-white   mb-2 ">
                Maintenance & Optimized
              </h2>
              <p className="text-center font-light text-own-ternary text-md">
                Slow loading website it’s the biggest problem for every website.
                I can boost your website’s speed by optimization your website.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyServices;
